import React from 'react';
import './App.css';
import Link from './Link';

import LionessLogo from './images/Lioness_Logo_Black_400.png';
import BaeLogo from './images/bae_logo.png';
import BaeBanner from './images/BAE0280+3.jpg';
import Infographic from './images/combined_infographic_biggerfont.png';

import UniversalRouter from 'universal-router';

import Lioness1 from './influencers/Lioness-1.jpg';
import Lioness2 from './influencers/Lioness-2.jpg';
import Lioness3 from './influencers/Lioness-3.jpg';
import Lioness4 from './influencers/Lioness-4.jpg';
import Lioness5 from './influencers/Lioness-5.jpg';
import Lioness6 from './influencers/Lioness-6.jpg';
import Lioness7 from './influencers/Lioness-7.jpg';
import Lioness8 from './influencers/Lioness-8.jpg';
import Lioness9 from './influencers/Lioness-9.jpg';
import Lioness10 from './influencers/Lioness-10.jpg';

import Diverse from './images/Sexual_Diverse.png';
import Masturbation from './images/masturbation_time.png';
import Orgasm from './images/orgasm_time.png';
import Multi from './images/Multi_Orgasm.png';

const App: React.FC = () => {
  return (
    <div className="App">
      <Header />
      <BannerSection />
      <AboutSection />
      <AggregateSection />
      <Footer />
    </div>
  );
};

const Header: React.FC = () => (
  <header className="header">
    <a href="https://lioness.io/?utm_source=data_campaign&utm_campaign=bae_lioness">
      <img className="header-logo" src={LionessLogo} alt="Lioness Logo" />
    </a>
    <span>&</span>
    <a href="https://baevapes.com/?utm_source=data_campaign&utm_campaign=bae_lioness">
      <img className="header-logo" src={BaeLogo} alt="Bae Logo" />
    </a>
  </header>
);

const BannerSection: React.FC = () => (
  <section className="banner">
    <div className="overlay" />
    <img src={BaeBanner} alt="Bae banner" />
    <BannerContent />
  </section>
);

const BannerContent: React.FC = () => (
  <div className="banner-content">
    <h2>Sex, Cannabis, and Data</h2>
    {
      //<button>{"What's This?"}</button>
    }
  </div>
);

const ResultsBox: React.FC = () => (
  <div className="results">
    <h3>Sexy results:</h3>
    <ul>
      <li>
        While not everyone was multi-orgasmic, over 70% of users reached
        multiple orgasms vs. less than 30% while sober.
      </li>
      <li>
        Users generally spent nearly half a minute more in orgasmic bliss while
        high, relative to their sober selves.
      </li>
      <li>
        Users seemed to enjoy the experience more and spent over a minute more
        on average masturbating when they were high.
      </li>
    </ul>
  </div>
);

const AboutSection: React.FC = () => (
  <section className="about">
    <h2>{'Ever wonder what high quality cannabis does for your sex life?'}</h2>
    <p>
      {`The cannabis climax connection is officially here. `}
      <a href="https://baevapes.com/?utm_source=data_campaign&utm_campaign=bae_lioness">
        Bae
      </a>
      {`, the luxury vapour pen made for women by women, has teamed up with the `}
      <a href="https://lioness.io/?utm_source=data_campaign&utm_campaign=bae_lioness">
        Lioness
      </a>
      {` smart vibrator to conduct a data-led study on the link between cannabis and a more satisfactory orgasm.`}
    </p>
    <p>{`The companies gifted Bae vape pens to seven influencers who own Lioness and volunteered to participate in the study. They consented to use Lioness technology to track their orgasms both with, and without, using the Bae cannabis vaporizer. `}</p>
    <ResultsBox />
  </section>
);

const AggregateSection: React.FC = () => (
  <section className="aggregate">
    <img src={Masturbation} alt="masturbation time" />
    <img src={Orgasm} alt="orgasm time" />
    <img src={Multi} alt="multiple orgasm" />
    <img src={Diverse} alt="sexual diversity" />
  </section>
);

const influencers = [
  Lioness1,
  Lioness2,
  Lioness3,
  Lioness4,
  Lioness5,
  Lioness6,
  Lioness7,
  Lioness8,
  Lioness9,
  Lioness10,
];

const Influencers: React.FC = () => {
  let infs = influencers.map(i => (
    <div className="influencer">
      <img src={i} />
      <h4>MyName</h4>
      <p>Description description stuff stuff</p>
    </div>
  ));

  return (
    <section className="influencers">
      <h2>Intrepid Participants</h2>
      <div className="influencers-boxes">{infs}</div>
    </section>
  );
};

const Footer: React.FC = () => {
  return (
    <div className="footer">
      © 2019. All rights reserved. SmartBod Incorporated. Lioness® is a trade
      name and registered trademark of SmartBod Incorporated.
    </div>
  );
};

const routes = [
  {
    path: '',
    action: () => <App />,
  },
  {
    path: '/footer',
    action: () => <Footer />,
  },
];

export const router = new UniversalRouter(routes);
export default App;
